import styled from 'styled-components';
export const ThirdPartyLoginWrapper = styled.div.withConfig({
  displayName: "LoginOptionsstyles__ThirdPartyLoginWrapper",
  componentId: "mv5y1z-0"
})(["display:flex;gap:10px;margin-bottom:12px;button{min-width:208px;overflow:hidden;}@media (min-width:426px){button{max-width:208px;div{padding-right:0;}}}@media (max-width:425px){flex-wrap:wrap;}"]);